import {
    CreateMatchPlayerCommandOfMatchPlayer,
    EventVm,
    UpdateEventCommand,
} from '../../../../utils/api';
import SwimOff from './SwimOff';

interface OwnProps {
    isHomeTeam: boolean;
    homeTeamId?: number;
    event: UpdateEventCommand;
    lineups: CreateMatchPlayerCommandOfMatchPlayer[];
    events: EventVm[];
    updateEvent: (event: UpdateEventCommand) => void;
    clearEvent: () => void;
    deleteEvent: (event: EventVm) => void;
}

export type Props = OwnProps;

export default SwimOff;
